import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom: "",
  idTo: "",
  titleesFrom: "",
  titleesTo: "",
  titleenFrom: "",
  titleenTo: "",
  owncodeFrom: "",
  owncodeTo: "",
  codeanFrom: "",
  codeanTo: "",
  barcodeFrom: "",
  barcodeTo: "",
  accountingcodeFrom:"",
  accountingcodeTo:"",
  marcaFrom:"",
  marcaTo:"",
  modeloFrom:"",
  modeloTo:"",
  locationFrom:"",
  locationTo:"",
  applytypesofsize:true,
  notapplytypesofsize:true,
  applycolor:true,
  notapplycolor:true,
  applynumserial:true,
  notapplynumserial:true,  
  isnewpiece:true,
  notisnewpiece:true,
  minimumstockFrom: "",
  minimumstockTo: "",
  maximumstockFrom: "",
  maximumstockTo: "",
  actualstockFrom: "",
  actualstockTo: "",
  salesunitsFromES: "",
  salesunitsToES: "",
  salesunitsFromEN: "",
  salesunitsToEN: "",
  departmentFromES: "",
  departmentToES: "",
  departmentFromEN: "",
  departmentToEN: "",
  sectionFromES: "",
  sectionToES: "",
  sectionFromEN: "",
  sectionToEN: "",
  subsectionFromES: "",
  subsectionToES: "",
  subsectionFromEN: "",
  subsectionToEN: ""
};

const filtersArticlesSlice = createSlice({
  name: 'filtersArticle',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersArticlesSlice.actions;
export default filtersArticlesSlice.reducer;
